import React, { useEffect }  from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import KontentRichText from "../components/kontentrichtext"

const AudioExtract = ({ data }) => {
  const item = data.kontentItemAudioExtract.elements
  const audioExtracts = item.audio_resources && item.audio_resources.value[0] && item.audio_resources.value[0].elements
  const singleAudioResource = item.single_audio_resource && item.single_audio_resource.value[0] && item.single_audio_resource.value[0].elements

  function onlyPlayOneIn(container) {
    container.addEventListener("play", function(event) {
    let i = 0
    const audio_elements = container.getElementsByTagName("audio")
      for(i=0; i < audio_elements.length; i++) {
        const audio_element = audio_elements[i];
        if (audio_element !== event.target) {
          audio_element.pause();
        }
      }
    }, true);
  }



  useEffect(() => {
    onlyPlayOneIn(document.body);
    if(!item || !item.allow_downloads || !item.allow_downloads.value || item.allow_downloads.value.length === 0 || item.allow_downloads.value[0].codename !== "allow_download") {
      var playerElements = document.querySelectorAll('#player');
      if (playerElements.length > 0) {
          playerElements.forEach(playerElement => {
              playerElement.addEventListener("contextmenu", e => e.preventDefault());
          });
      }
    }
  }, []);

  return (
    <Layout>
      <SEO title={item.title.value} />
      {item.banner_image.value[0] && 
      <div className="section-wide">
        <div className="container">
          <div className="banner-wrapper banner-editable">
            <img
              src={item.banner_image.value[0].url}
              alt={item.banner_image.value[0].description}
              className="banner-image"
            />
          </div>
        </div>
      </div>
      }
      <div className="section body">
        <div className="container">
          <div className="intro-wrapper"></div>
          <div className="clear-body-wrapper border-bottom">
            <div className="row w-clearfix">
              <div className="col-6">
                <div className="image-wrapper">
                  {item.jacket_image.value[0] ? (
                    <img
                      src={item.jacket_image.value[0].url}
                      alt={item.jacket_image.value[0].description}
                      className="book-image"
                    />
                  ) : (
                    <span></span>
                  )}
                </div>
              </div>
              <div className="col-6">
                <h1>{item.title.value}</h1>
                <h4 className="highlight--red">
                  {item.author___illustrator.value}
                </h4>
                {item.narrator.value && <h4 className="highlight--red">Read by {item.narrator.value}</h4>}
                {item.audio_extract.value && item.audio_extract.value[0] && 
                <div className="audio--content--wrapper">
                  <div className="audio--subhead">
                    Listen to {item.title.value}
                  </div>
                  <audio id="player" controls controlsList="nodownload">
                    <source
                      id="mp3_source"
                      type="audio/mpeg"
                      src={item.audio_extract.value[0].url}
                    />
                    Your browser does not support the audio element.
                  </audio>
                </div>
                }
                {singleAudioResource && singleAudioResource.resource.value[0] && 
                <div className="audio--content--wrapper">
                  <div className="audio--subhead">
                    Listen to {singleAudioResource.title.value}
                  </div>
                  <audio id="player" controls controlsList="nodownload">
                    <source
                      id="mp3_source"
                      type="audio/mpeg"
                      src={singleAudioResource.resource.value[0].url}
                    />
                    Your browser does not support the audio element.
                  </audio>
                </div>
                }
                {audioExtracts && 
                <div className="audio--content--wrapper">
                  {audioExtracts.audio_resources.value.map((item, i) => {
                   return (<div key={`audio-extract-${i}`} className="audio--wrapper">
                    <div className="audio--subhead">
                    {item.elements.title && item.elements.title.value}
                    </div>
                    <audio id="player" controls controlsList="nodownload" oncontextmenu="return false;">
                      <source
                        id="mp3_source"
                        type="audio/mpeg"
                        src={item.elements.resource.value && item.elements.resource.value[0].url}
                      />
                      Your browser does not support the audio element.
                    </audio>
                    </div>
                    )
                  })}
                </div>
                }
                <div className="synopsis-wrapper">
                  <h3>Synopsis</h3>
                  {item.synopsis && (
                    <KontentRichText item={item.synopsis} />
                  )}
                  
                </div>
              </div>
            </div>
            {item.additional_content && 
            <div className="row w-clearfix" style={{marginTop:"60px"}}>
              <div className="col-2"></div>
              <div className="col-8">
                <div className="centre-wrapper">
                  {item.additional_content && (
                      <KontentRichText item={item.additional_content} />
                    )}
                </div>
              </div>
            </div>
            }
          </div>
          {item.imprint.value[0] && 
          <div className="row w-clearfix">
            <div className="col-2"></div>
            <div className="col-8">
              <div className="centre-wrapper">
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      item.imprint.value[0].elements.description.value,
                  }}
                />
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </Layout>
  )
}

export default AudioExtract

export const query = graphql`
  query audioExtractQuery($slug: String!) {
    kontentItemAudioExtract(
      elements: { url: { value: { eq: $slug } } }
    ) {
      elements {
        imprint {
          value {
            ... on kontent_item_imprint {
              id
              elements {
                description {
                  value
                }
              }
            }
          }
        }
        url {
          value
        }
        title {
          value
        }
        single_audio_resource {
          value {
            ... on kontent_item_audio_resource {
              id
              elements {
                title {
                  value
                }
                resource {
                  value {
                    url
                  }
                }
              }
            }
          }
        }
        allow_downloads {
          name
          value {
            codename
            name
          },
        }
        audio_extract {
          value {
            url
          }
        }
        author___illustrator {
          value
        }
        narrator {
          value
        }
        banner_image {
          value {
            url
            description
          }
        }
        synopsis {
          modular_content {
            system {
              type
              name
              codename
            }
            id
          }
          value
          links {
            url_slug
            type
            link_id
            codename
          }
          images {
            width
            url
            image_id
            height
            description
          }
        }
        additional_content {
          modular_content {
            system {
              type
              name
              codename
            }
            ... on kontent_item_image_collection {
              id
              elements {
                title {
                  value
                }
                introduction {
                  value
                }
                images {
                  value {
                    url
                    width
                    name
                    height
                    description
                  }
                }
              }
            }
            id
          }
          value
          links {
            url_slug
            type
            link_id
            codename
          }
          images {
            width
            url
            image_id
            height
            description
          }
        }
        jacket_image {
          value {
            url
            description
          }
        }
        audio_resources {
          value {
            ... on kontent_item_audio_resource_list {
              id
              elements {
                title {
                  value
                }
                introduction {
                  modular_content {
                    system {
                      type
                      name
                      codename
                    }
                    id
                  }
                  value
                  links {
                    url_slug
                    type
                    link_id
                    codename
                  }
                  images {
                    width
                    url
                    image_id
                    height
                    description
                  }
                }
                audio_resources {
                  value {
                    id
                    ... on kontent_item_audio_resource {
                      id
                      elements {
                        title {
                          value
                        }
                        resource {
                          value {
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
